import {action, observable, computed, makeObservable} from 'mobx';
import {DesignCollection} from './DesignCollection';
import {Field} from '../../Common/stores/Field';
import {hiddenFieldTypes} from '../../../../constants/FieldConsts';

export class DesignField extends Field {
    @observable grouped;
    @observable packageName;

    // we need to save initial hidden value, because there're two hidden types;
    // if we switch from hidden to visible and back to hidden, we need to return to the initial type of hidden
    initialHidden;
    /* key used in package data */
    exec;
    /* package id */
    packId;

    constructor(field, parentField) {
        super(field, parentField);
        makeObservable(this);
        this.initialHidden = field.hidden;
        this.exec = field.exec && field.exec !== '0' ? field.exec : field.name;
        this.collection = new DesignCollection(parentField.collection);
    }

    setCollection(field) {
        field.fields && this.collection.insertFields(this, field.fields);
    }

    toggleHide() {
        let dest;
        if (this.hidden) {
            dest = this.parentCollection.firstHiddenIdx;
            this.setHide(null);
        } else {
            dest = this.parentCollection.firstHiddenIdx - 1;
            this.setHide(this.initialHidden ? this.initialHidden : hiddenFieldTypes.HIDDEN);
        }
        this.parentCollection.moveField(this, dest);
        this.screen.setActive(null);
    }

    @action
    setGrouped(value) {
        this.grouped = value;
    }

    get packageId() {
        if (!this.packId) {
            this.packId = this.screen.getPackageId(this.exec);
        }
        return this.packId;
    }

    @computed get isMovable() {
        return !this.hidden;
    }

    // we can't hide "needed" field and last field in the list
    @computed get isHiddenStatusUnchangable() {
        return (
            !this.hidden &&
            (this.needed || (this.index === 0 && (!this.nextField || this.nextField.hidden)))
        );
    }

    @computed
    get isDoubleTitleAllowed() {
        return true;
    }
}
